import { UPDATE_THEME_FROM_EDITOR } from '../actions/ThemeAction';
import initialState from '../../commons/styles/blackThemeSettings.json';

const ThemeReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_THEME_FROM_EDITOR:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export default ThemeReducer;